module.exports = __webpack_public_path__ + "media/images/room/room_live_v1-6d140d3006fec01c6bbd8a22ac45b458.png";